import { DefaultEnvConnectionErrorPage } from './DefaultEnvConnectionErrorPage';
import { SweepError } from '@server/sweep-errors';
import type { EnvConnectionError } from './envConnectionErrorTypes';
import { SfEnvConnectionErrorPage } from './SfEnvConnectionErrorPage';
import { RequestLimitEnvConnectionErrorPage } from './RequestLimitEnvConnectionErrorPage';

export const EnvConnectionErrorPage = ({
  envConnectionError,
}: {
  envConnectionError: EnvConnectionError;
}) => {
  const { error } = envConnectionError;

  if (error === SweepError.CrmOrgBadCredentials) {
    return <SfEnvConnectionErrorPage envConnectionError={envConnectionError} />;
  }
  if (
    [
      SweepError.RequestLimitExceededTotalRequests,
      SweepError.RequestLimitExceededConcurrentRequests,
    ].includes(error)
  ) {
    return <RequestLimitEnvConnectionErrorPage />;
  }

  return <DefaultEnvConnectionErrorPage />;
};
